// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___RJvgg","root__title":"style-module__root__title___qvWGn"};
    if(module.hot) {
      // 1697460456623
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  